"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function cny(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.87825 5.625H17.2402V7.06875H6.8775L6.87825 5.625ZM5.72325 9.85575H18.528V11.3145H14.6055V16.1947C14.6055 16.5697 14.7682 16.7572 15.108 16.7572H16.737C16.9148 16.7572 17.0625 16.6425 17.151 16.4257C17.2552 16.1947 17.3288 15.4867 17.3588 14.3175L18.75 14.751C18.6465 16.3822 18.4537 17.3498 18.1875 17.6535C17.9213 17.9415 17.5365 18.1005 17.0175 18.1005H14.6647C13.6132 18.1005 13.0958 17.5665 13.0958 16.512V11.3145H10.9042V11.6032C10.8307 13.437 10.4167 14.9093 9.6615 16.0072C8.92125 17.0175 7.737 17.8118 6.07875 18.375L5.25 17.1045C6.849 16.5555 7.91475 15.8625 8.47725 15.054C9.03975 14.1585 9.33525 13.0177 9.3945 11.6032V11.3145H5.724L5.72325 9.85575Z", fill: color }));
}
exports["default"] = cny;
//# sourceMappingURL=cny.js.map